
/* Delete-3 loader: when to open (no DOM writes until it opens), the labels' click, keeping the code applied. */
(function () {
  'use strict';
  var d = document, html = d.documentElement, C;
  try { C = JSON.parse(d.getElementById('d3-config').textContent); } catch (e) { return; }
  var KEY = 'lagom_theme_d3', CLOSED = 'lagom_theme_d3_closed', SHOWN = 'lagom_theme_d3_shown', PENDING = 'lagom_theme_d3_pending', TAB = 'lagom_theme_d3_tab', TABHID = 'lagom_theme_d3_tab_hidden';
  function store(s, k, v) { try { var o = window[s]; if (v === undefined) { return o.getItem(k); } if (v === null) { o.removeItem(k); } else { o.setItem(k, v); } } catch (e) { return null; } }
  var unlocked = store('localStorage', KEY) === '1';
  /* side tab: after the popup was closed without signing up, until signup or its ✕ (hidden for [re-show] days) */
  function tab(on) { html.classList.toggle('d3-has-tab', !!on); }   // not 'd3-tab': that is the tab's own class
  var tabHidAt = +store('localStorage', TABHID) || 0;
  if (!unlocked && store('localStorage', TAB) && !(tabHidAt && Date.now() - tabHidAt < C.reshow * 864e5)) { tab(true); }
  d.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-d3-tab-hide]')) { return; }
    store('localStorage', TABHID, String(Date.now())); tab(false);
  });
  var idle = function (fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 1); })(fn, { timeout: 2000 }); };

  /* keep the code on the cart/checkout: quietly again on every page while it is not in the discount cookie */
  function applyCode() {
    if (!C.code) { return Promise.resolve(); }
    return fetch(C.root.replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(C.code) + '?redirect=' + encodeURIComponent(C.root.replace(/\/?$/, '/') + 'cart.js'), { credentials: 'same-origin' }).catch(function () {});
  }
  if (unlocked && C.code && d.cookie.indexOf('discount_code=' + encodeURIComponent(C.code)) === -1) { idle(applyCode); }

  var mod = null, loading = null;
  function load() {
    if (mod) { return Promise.resolve(mod); }
    if (!loading) {
      var css = new Promise(function (res) { var l = d.createElement('link'); l.rel = 'stylesheet'; l.href = C.css; l.onload = l.onerror = res; d.head.appendChild(l); });
      loading = Promise.all([import(C.js), css]).then(function (r) { mod = r[0]; return mod; });
    }
    return loading;
  }
  function unlock() {
    unlocked = true; store('localStorage', KEY, '1'); store('localStorage', CLOSED, null); store('localStorage', TAB, null); html.classList.add('d3-on'); tab(false);
    return applyCode();
  }
  function open(force, opts) {
    return load().then(function (m) {
      m.open(Object.assign({ config: C, unlock: unlock, pendingKey: PENDING, onClose: function (signedUp) {
        if (signedUp) { return; }
        if (!force) { store('localStorage', CLOSED, String(Date.now())); }
        store('localStorage', TAB, '1'); store('localStorage', TABHID, null); tab(true);   // the side tab stays on the left
      } }, opts || {}));
    }).catch(function (e) { if (window.console) { console.error('delete3', e); } loading = null; });
  }
  window.Lagom = window.Lagom || {}; window.Lagom.delete3 = { open: function () { return open(true); } };

  /* the labels and the cart line: always open it */
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-d3-open]'); if (!t) { return; }
    e.preventDefault(); e.stopPropagation();
    if (!t.closest('[data-cart-panel]')) { d.dispatchEvent(new CustomEvent('lagom:panel', { detail: 'delete3' })); }   // closes the menu (and the cart, unless it was opened from the cart: then the cart stays open under the popup)
    open(true);
  }, true);   // capture: the cart window stops clicks from bubbling
  d.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('[data-d3-open]')) { load(); } }, { passive: true, once: true });

  var params = new URLSearchParams(location.search);
  /* back from the signup (snippets: the popup submits Shopify's customer form normally): success, or an email
     error = already a customer -> unlocked, the popup reopens on the success screen. Anything else: the popup
     reopens on the form with the error (data-d3-result="error"). */
  if (store('sessionStorage', PENDING)) {
    var res = d.querySelector('[data-d3-result]'), r = res ? res.getAttribute('data-d3-result') : '', msg = res ? res.getAttribute('data-d3-msg') || '' : '';
    if (params.get('customer_posted') === 'true' || r === 'ok' || r === 'email' || /already|taken|exist|subscrib/i.test(msg)) {
      var y = +store('sessionStorage', PENDING + '_y') || 0;
      store('sessionStorage', PENDING, null); store('sessionStorage', PENDING + '_y', null);
      if (history.replaceState) { params.delete('customer_posted'); history.replaceState(null, '', location.pathname + (params.toString() ? '?' + params : '') + location.hash.replace(/^#d3-native$/, '')); }
      if (y) { try { history.scrollRestoration = 'manual'; } catch (e) {} window.scrollTo(0, y); }   // back at the same spot
      unlock(); open(true, { done: true, instant: true }); return;
    }
    if (r === 'error') { store('sessionStorage', PENDING, null); open(true, { failed: true }); return; }
  }
  if (params.get('popup') === '1') { open(true); return; }
  if (!C.enabled || !C.auto || unlocked) { return; }
  if (store('sessionStorage', SHOWN)) { return; }
  var closedAt = +store('localStorage', CLOSED) || 0;
  if (closedAt && Date.now() - closedAt < C.reshow * 864e5) { return; }

  var t0 = Date.now(), fired = false, timers = [], scrollT = 0;
  function blocked() {
    var cart = d.querySelector('[data-cart-panel]'), menu = d.querySelector('[data-menu]');   // the cookie banner does not block it: it steps aside while the popup is open (delete3.css)
    return (cart && cart.classList.contains('is-open')) || (menu && menu.classList.contains('is-open')) || html.classList.contains('is-locked') || d.visibilityState === 'hidden' || (window.visualViewport && visualViewport.scale > 1.05);   // pinch-zoomed in: the popup would fill the screen (waits until zoomed out)
  }
  function fire() {
    if (fired) { return; }
    if (html.classList.contains('wl-on')) { fired = true; return; }   // a country we don't sell to: the waitlist instead (snippets/waitlist-head.liquid)
    if (blocked()) { timers.push(setTimeout(fire, 1500)); return; }   // wait until the banner/cart/menu is closed
    fired = true; timers.forEach(clearTimeout);
    removeEventListener('scroll', onScroll); d.removeEventListener('mouseout', onExit);
    store('sessionStorage', SHOWN, '1');
    open(false);
  }
  function onScroll() {
    if (scrollT) { return; }
    scrollT = setTimeout(function () {
      scrollT = 0;
      var max = html.scrollHeight - innerHeight; if (max <= 0) { return; }
      if (scrollY / max * 100 >= C.scroll) {
        var wait = C.min * 1000 - (Date.now() - t0);
        removeEventListener('scroll', onScroll);
        if (wait > 0) { timers.push(setTimeout(fire, wait)); } else { fire(); }
      }
    }, 200);
  }
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) { fire(); } }
  timers.push(setTimeout(fire, C.delay * 1000));
  if (C.scroll > 0) { addEventListener('scroll', onScroll, { passive: true }); }
  if (C.exit && matchMedia('(hover: hover) and (pointer: fine)').matches) { d.addEventListener('mouseout', onExit); }
})();
